import { get, post, del } from '@/services/http';
import { InventoryTransferRouteModel } from '@/models/inventory_transfer_route';
import List from './list';

export class InventoryTransferRouteList extends List<InventoryTransferRouteModel> {

  public async fetch() {
    const res: any = await get(`/inventory-transfer-routes`, {});
    const routes = res || [];
    this.items = []; // Clear existing items
    for (const data of routes) {
      const routeModel = new InventoryTransferRouteModel();
      routeModel.mapData(data);
      this.add(routeModel);
    }
    return this.items;
  }

  public async batchUpdatePriorities(sourceLocationId: number, routes: Array<{id: number, priority: number}>) {
    if (routes.length === 0) {
      return;
    }
    await post('/inventory-transfer-routes/batch-update-priorities', {
      source_location_id: String(sourceLocationId),
      routes,
    });
  }

  public async delete(route: InventoryTransferRouteModel): Promise<void> {
    if (!route.id) {
      throw new Error('Cannot delete a route without an ID.');
    }
    await del(`/inventory-transfer-routes/${route.id}`);
    this.remove(route);
  }

  public getRoutesByDestination(destinationLocationId: number): InventoryTransferRouteModel[] {
    return this.items
      .filter((route) => route.destinationLocationId === destinationLocationId)
      .sort((a, b) => a.priority - b.priority);
  }
}
